export const Roles = [
	{ id: 'CAPTAIN', label: 'Captain'},
	{ id: 'CHEF', label: 'Chef'},
	{ id: 'PURSER', label: 'Purser'},
	{ id: 'FIRST OFFICER', label: 'First Officer'},
	{ id: 'CHIEF STEWARDESS', label: 'Chief Stewardess'},
	{ id: 'CHIEF ENGINEER', label: 'Chief Engineer'},
	{ id: 'OTHER', label: 'Other'},
	{ id: 'ROTATE CAPTAIN', label: 'Rotate Captain'},

];

export const DataConf = {
	initialState: {
		loading: false,
		error: null,
		data: [],
		meta: null,
	},
};

export const PriorityOptions = [
	{ id: 'Low', label: 'Low' },
	{ id: 'Medium', label: 'Medium' },
	{ id: 'High', label: 'High' },
];

export const TargetOptions = [
	{ id: 'Guest', label: 'Guest' },
	{ id: 'Crew', label: 'Crew' },
	{ id: 'Other', label: 'Other' },
];

export const StarsOptions = [
	{ id: 'One', label: 'One' },
	{ id: 'Two', label: 'Two' },
	{ id: 'Three', label: 'Three' },
	{ id: 'Four', label: 'Four' },
	{ id: 'Five', label: 'Five' },
]


export const UsersType= [
	{ label: 'Crew', id: 'Crew' },
	{ label: 'Nautica', id: 'Nautica' },
  ]